<template>
    <div>
        <div class="mps-actions">
            <label>
              <input @keyup.enter="$root.toDamages(true)" id="regnr" v-model="$root.request.car_id" type="text" name="regnr" placeholder="AB12345 eller ABC123"/>
            </label>
            <button class="button" @click.prevent="$root.toDamages(true)" :disabled="$root.ui.loading" id="gtm-inquiry-continue-license">Fortsett</button>
        </div>
        <a @click.prevent="$root.toDamages(false)" href="#" class="skip-license" id="gtm-inquiry-skip-license">Fortsett uten reg.nr</a>
    </div>
</template>

<script>
export default {
  data () {
    return {}
  }
}
</script>

<style lang="scss">
</style>


// WEBPACK FOOTER //
// StartActions.vue?48ffb163